import * as Yup from 'yup';

export const siteRepresentativeInviteSchema = Yup.object().shape({
  firstName: Yup.string().required('REQUIRED'),
  lastName: Yup.string().required('REQUIRED'),
  email: Yup.string().email('INVALID_EMAIL').required('REQUIRED'),
  role: Yup.object().nullable().required('REQUIRED'),
});